'use client'

import React, {useMemo} from "react";
import {Formik, Form as FormikForm} from "formik";
import {capitalize} from "@/helpers/capitalize";
import FormObserver from "@/components/UI/Form/Form/FormObserver/FormObserver";

const Form = ({children, initialValues, scheme, onSubmit, submitOnChange, api, endpoint, method= 'mutation', payloadMapper, onChange, ...props}) => {
    const methodNamesMap = useMemo(() => ({
        'mutation': `use${capitalize(endpoint)}Mutation`,
        'query': `useLazy${capitalize(endpoint)}Query`,
    }), [endpoint]);

    const mutationName = useMemo(() => methodNamesMap[method], [methodNamesMap, method])

    const [action, response] = api?.[mutationName]?.({
        fixedCacheKey: `${endpoint}.form`,
    }) ?? [() => {}, {}]

    return (
        <Formik
            initialValues={initialValues ?? {}}
            validationSchema={scheme}
            onSubmit={async (values, {setErrors, setSubmitting}) => {
                const {error} = await action(payloadMapper?.(values) || values)

                setErrors(error?.data?.message)
                setSubmitting(false)
            }}
        >
            {
                ({errors, values, isValid, validateForm, setTouched, handleSubmit}) => (
                <FormikForm
                    {...props}
                    onSubmit={(e) => {
                        e.preventDefault();
                        validateForm().then((formErrors) => {
                            if (Object.keys(formErrors).length > 0) {
                                setTouched(
                                    Object.keys(errors).reduce((acc, key) => {
                                        acc[key] = true;
                                        return acc;
                                    }, {})
                                );
                            } else {
                                handleSubmit(e);
                            }
                        });
                    }}
                >
                    {/*<pre>{JSON.stringify(values, null, 4)}</pre>*/}
                    {(submitOnChange && isValid) && <FormObserver values={values} onChange={action}/>}
                    {(onChange && !submitOnChange && isValid) && <FormObserver values={values} onChange={onChange}/>}
                    {children}
                </FormikForm>)
            }
        </Formik>
    );
};

export default Form;